import { Button, Divider, Form, Input, Select } from "antd";
import { ApiService } from "api/api.service";
import { StrategyPurpose } from "../functions";
import { PercentInput, Question, StepHeading } from "./ui";

const DetailsStep = ({ orgCode }: { orgCode?: string }) => {
  const getOrganisationDetails = ApiService.organisation.useGetBySlug(orgCode);
  const pandaDocConfig = getOrganisationDetails.data?.pandadoc_mappings ?? [];
  const purpose: StrategyPurpose | undefined = Form.useWatch("purpose", { preserve: true });
  const isSettlement = purpose === "settlement";

  return (
    <>
      <StepHeading
        step={4}
        title={isSettlement ? "Creditors & details" : "Name this strategy"}
        description={
          isSettlement
            ? "Last step — how much creditors get back, and what to call this plan."
            : "Last step — give the plan a name the manager will recognise."
        }
      />

      {isSettlement && (
        <>
          <Question title="Payback ratio" hint="Share of the debt repaid to creditors. Creditors are paid via FCDS.">
            <Form.Item name={["creditor_split", "total_payback"]} noStyle>
              <PercentInput aria-label="Payback ratio" className="!w-60" />
            </Form.Item>
          </Question>
          <Divider className="!mt-0" />
        </>
      )}

      {isSettlement && <div className="text-[15px] font-semibold text-gray-900 mb-3">Name this strategy</div>}
      <Form.Item
        name="key"
        label="Title"
        rules={[{ required: true, whitespace: true, message: "Give this strategy a title" }]}
      >
        <Input placeholder="Standard program v1" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea autoSize={{ minRows: 2, maxRows: 3 }} placeholder="Optional details the manager will see" />
      </Form.Item>
      <Form.Item name="template_id" label="PandaDoc template">
        <Select
          allowClear
          loading={getOrganisationDetails.isPending}
          placeholder="Select a PandaDoc template"
          options={pandaDocConfig.map((config) => ({ label: config.title, value: config._id }))}
          popupRender={(menu) => (
            <>
              {menu}
              <Divider style={{ margin: "8px 0" }} />
              <div style={{ padding: 8 }}>
                <Button
                  type="primary"
                  block
                  onClick={() => window.open("/dashboard/application/key-mapping?org_code=" + orgCode, "_blank")}
                >
                  + Create New Template
                </Button>
              </div>
            </>
          )}
        />
      </Form.Item>
    </>
  );
};

export default DetailsStep;
